import { IconBag } from 'central-icons/IconBag';
import isEmpty from 'lodash/isEmpty';

import { Link, Text } from '@revelio/ui';

import styles from './card-sections.module.css';
import layoutStyles from './work-history-section.module.css';

interface WorkHistoryItem {
  current_title?: string;
  current_company?: string;
  start_date?: string;
  end_date?: string;
}

interface WorkHistorySectionProps {
  workHistory: WorkHistoryItem[];
  isExpanded: boolean;
  onToggleExpanded: () => void;
}

const formatDateToYear = (dateString: string) => {
  if (isEmpty(dateString)) return '';
  const [year] = dateString.split('-');
  return year;
};

export const WorkHistorySection = ({
  workHistory,
  isExpanded,
  onToggleExpanded,
}: WorkHistorySectionProps) => {
  if (!workHistory.length) return null;

  const sortedHistory = workHistory.sort((a, b) => {
    const aDate = String(a.start_date ?? '');
    const bDate = String(b.start_date ?? '');
    if (aDate > bDate) return -1;
    if (aDate < bDate) return 1;
    return 0;
  });

  const currentPosition = sortedHistory[0];
  const previousPositions = sortedHistory.slice(1);
  const displayPreviousPositions = isExpanded
    ? previousPositions
    : previousPositions.slice(0, 1);

  return (
    <div className={layoutStyles.section}>
      <div className={layoutStyles.sectionIcon}>
        <IconBag size={16} />
      </div>
      <div className={layoutStyles.positionList}>
        <Text fontSize="sm">
          <Text as="span" fontSize="sm">
            {String(currentPosition?.current_title ?? '')}
          </Text>
          {/** biome-ignore lint/style/useConsistentCurlyBraces: migrated from develop */}
          {' @ '}
          <Text as="span" fontSize="sm">
            {String(currentPosition?.current_company ?? '')}
          </Text>{' '}
          ({formatDateToYear(String(currentPosition?.start_date ?? ''))}-
          {currentPosition?.end_date
            ? formatDateToYear(String(currentPosition.end_date))
            : 'present'}
          )
        </Text>

        {displayPreviousPositions.map((position, idx) => {
          const isLastDisplayedPosition =
            idx === displayPreviousPositions.length - 1;
          return (
            <Text key={idx} fontSize="sm">
              <Text as="span" fontSize="sm">
                {String(position.current_title ?? '')}
              </Text>
              {/** biome-ignore lint/style/useConsistentCurlyBraces: migrated from develop */}
              {' @ '}
              <Text as="span" fontSize="sm">
                {String(position.current_company ?? '')}
              </Text>{' '}
              ({formatDateToYear(String(position.start_date ?? ''))}-
              {position.end_date
                ? formatDateToYear(String(position.end_date))
                : 'present'}
              )
              {isLastDisplayedPosition && previousPositions.length > 1 && (
                <>
                  {' '}
                  <Link
                    className={styles.moreLink}
                    onClick={(e) => {
                      e.stopPropagation();
                      onToggleExpanded();
                    }}
                  >
                    {isExpanded ? 'Show Less' : 'More'}
                  </Link>
                </>
              )}
            </Text>
          );
        })}
      </div>
    </div>
  );
};
